import type { TradeColor } from '@/types/scheduler';

/** The fixed palette keys, in swatch order. Matches the backend TRADE_COLORS. */
export const TRADE_COLOR_KEYS: TradeColor[] = [
  'blue',
  'teal',
  'amber',
  'green',
  'gray',
  'coral',
  'pink',
  'purple',
];

/** Badge classes per palette key (light/dark safe — never an arbitrary hex). */
export const TRADE_COLOR_CLASS: Record<TradeColor, string> = {
  blue: 'bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-900/30 dark:text-blue-300 dark:border-blue-800',
  teal: 'bg-teal-100 text-teal-800 border-teal-200 dark:bg-teal-900/30 dark:text-teal-300 dark:border-teal-800',
  amber:
    'bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-800',
  gray: 'bg-gray-100 text-gray-700 border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-700',
  green:
    'bg-green-100 text-green-800 border-green-200 dark:bg-green-900/30 dark:text-green-300 dark:border-green-800',
  coral:
    'bg-orange-100 text-orange-800 border-orange-200 dark:bg-orange-900/30 dark:text-orange-300 dark:border-orange-800',
  pink: 'bg-pink-100 text-pink-800 border-pink-200 dark:bg-pink-900/30 dark:text-pink-300 dark:border-pink-800',
  purple:
    'bg-purple-100 text-purple-800 border-purple-200 dark:bg-purple-900/30 dark:text-purple-300 dark:border-purple-800',
};

/** Solid dot class per palette key (for select options + the grid name cell). */
export const TRADE_DOT_CLASS: Record<TradeColor, string> = {
  blue: 'bg-blue-500',
  teal: 'bg-teal-500',
  amber: 'bg-amber-500',
  gray: 'bg-gray-400',
  green: 'bg-green-500',
  coral: 'bg-orange-500',
  pink: 'bg-pink-500',
  purple: 'bg-purple-500',
};

/** Resolve a possibly-unknown color string to a valid palette key (→ gray). */
export function tradeColorKey(color: string | null | undefined): TradeColor {
  return color && color in TRADE_COLOR_CLASS ? (color as TradeColor) : 'gray';
}

export function tradeBadgeClass(color: string | null | undefined): string {
  return TRADE_COLOR_CLASS[tradeColorKey(color)];
}

export function tradeDotClass(color: string | null | undefined): string {
  return TRADE_DOT_CLASS[tradeColorKey(color)];
}
